import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './PublicSpaceSection.css';

const PublicSpaceSection = () => {
  const [ref, inView] = useInView({
    threshold: 0.2,
    triggerOnce: true
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    }
  };


  return (
    <section className="public-space-section section" id="public-space">
      <div className="container">
        <motion.div 
          ref={ref}
          className="public-space-content"
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          <motion.div className="section-header" variants={itemVariants}>
            <h2 className="section-title">
              الحيّز العام والمجتمع
            </h2>
          </motion.div>

          <motion.div className="concept-explanation" variants={itemVariants}>
            <div className="concept-card">
              <div className="concept-icon">🏙️</div>
              <div className="concept-content">
                <p>
                  الحيّزات العامة هي الأماكن التي تتقاطع فيها حياتنا اليومية – في الشوارع، الحدائق، الأسواق، المراكز الثقافية وأماكن اللقاء التي تُشكّل هوية مجتمعنا. فهي ليست أماكن مادية فقط، بل فضاءات اجتماعية تنمو فيها الأفكار والعلاقات والثقافة. من خلال التركيز على الحيّز العام، نطمح إلى استكشاف كيف يمكن للتصميم، والفن، والمبادرات الاجتماعية، والتخطيط الحضري، والتعليم، بل وحتى التكنولوجيا، أن تلتقي معًا لإعادة تخيّل أسلوب عيشنا جنبًا إلى جنب. لكل فرد – سواء كان من مجالات الهندسة المعمارية، أو علم الاجتماع، أو القانون، أو الصحة، أو البيئة، أو أي مجال آخر – دور مهم في جعل هذه الفضاءات المشتركة أكثر شمولًا وحيوية ومعنى للمجتمع.
                </p>
              </div>
            </div>
          </motion.div>


          <motion.div className="call-to-action" variants={itemVariants}>
            <div className="cta-content">
              <h3>انضم إلينا في إعادة تخيّل الحيّز العام</h3>
              <p>
                سواء كنت من مجالات التصميم، الهندسة، الفن، التعليم، أو أي مجال آخر، 
                لديك دور مهم في جعل الفضاءات المشتركة أكثر شمولًا وحيوية ومعنى للمجتمع
              </p>
            </div>
            <div className="cta-features">
              <div className="feature-item">
                <span className="feature-icon">🎨</span>
                <span>التصميم والفن</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">🏗️</span>
                <span>التخطيط الحضري</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">🤝</span>
                <span>المبادرات الاجتماعية</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">💻</span>
                <span>التكنولوجيا</span>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default PublicSpaceSection;
